import { Tabs } from "antd";
import { useState } from "react";
import { useHistory, useParams } from "react-router";
import FeatureTemplateProjectSettings from "components/manage-feature-wf-templates/feature-template-project-settings";
import { FeatureTypes } from "entity-app/constants";
import FeatureRenamedFieldSettings from "components/feature-rename-fields-settings";

function DesignPackageSettings(props: {
  designPackageHeader: any;
  disabled: boolean;
}) {
  const { designPackageHeader, disabled } = props;

  const history = useHistory();
  const { projectId, tab3Id } = useParams() as any;

  const [selectedTab, setSelectedTab] = useState<string>(tab3Id || "templates");

  const tabItems = [
    {
      label: <span className="pl-2.5">Design Package Templates</span>,
      key: "templates",
      children: (
        <FeatureTemplateProjectSettings
          featureId={FeatureTypes.DESIGN_PACKAGE}
        />
      )
    },
    {
      label: <span className="pl-2.5">Rename Fields</span>,
      key: "rename-fields",
      children: (
        <FeatureRenamedFieldSettings
          featureId={FeatureTypes.DESIGN_PACKAGE}
          disabled={disabled}
          columnHeader={designPackageHeader}
        />
      )
    }
  ];

  return (
    <div className="w-full bg-white h-full module-settings--tabs">
      <Tabs
        tabPosition="left"
        tabBarGutter={2}
        tabBarStyle={{ width: "225px" }}
        activeKey={selectedTab}
        items={tabItems}
        onChange={(activeKey) => {
          history.push(
            `/project/${projectId}/settings/modules/design-packages/${activeKey.toString()}`
          );
          setSelectedTab(activeKey);
        }}
        destroyInactiveTabPane
      />
    </div>
  );
}

export default DesignPackageSettings;
